import { useEffect } from "react";
import { useLang } from "../i18n";

const BASE = process.env.REACT_APP_BACKEND_URL || "";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

const setLink = (rel, href, hreflang) => {
  const sel = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]`;
  let el = document.head.querySelector(sel);
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); if (hreflang) el.setAttribute("hreflang", hreflang); document.head.appendChild(el); }
  el.setAttribute("href", href);
};

export const Seo = ({ title, description, path = "", type = "website", jsonLd }) => {
  const { lang, t } = useLang();
  const finalTitle = title ? `${title} | Bula Telecoms` : t.meta.homeTitle;
  const desc = description || t.meta.homeDesc;

  useEffect(() => {
    document.documentElement.lang = lang;
    document.title = finalTitle;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", finalTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", type);
    setMeta("property", "og:site_name", "Bula Telecoms SA");
    setMeta("property", "og:url", `${BASE}/${lang}${path ? `/${path}` : ""}`);
    setMeta("name", "twitter:card", "summary_large_image");
    const clean = path.replace(/^\/+/, "");
    const frUrl = `${BASE}/fr${clean ? `/${clean}` : ""}`;
    const enUrl = `${BASE}/en${clean ? `/${clean}` : ""}`;
    setLink("canonical", lang === "fr" ? frUrl : enUrl);
    setLink("alternate", frUrl, "fr");
    setLink("alternate", enUrl, "en");
    setLink("alternate", frUrl, "x-default");

    let ld = document.getElementById("bt-jsonld");
    if (!ld) { ld = document.createElement("script"); ld.type = "application/ld+json"; ld.id = "bt-jsonld"; document.head.appendChild(ld); }
    ld.textContent = JSON.stringify(jsonLd || {
      "@context": "https://schema.org", "@type": "Organization", name: "Bula Telecoms SA",
      url: BASE, email: "info@bulatelecoms.com", telephone: "+243 904 444 213",
      address: { "@type": "PostalAddress", streetAddress: "Immeuble Quantum, 2ème étage, 81/77 Boulevard du 30 Juin", addressLocality: "Kinshasa-Gombe", addressCountry: "CD" },
    });
  }, [finalTitle, desc, lang, path, type, jsonLd]);

  return null;
};
